<template>
  <tr :class="{'clickable': $can('edit', 'Contractor')}">
    <td>
      {{ contractor.name }}
    </td>
    <td>
      {{ typeLabel }}
    </td>
    <td>
      {{ contractor.description }}
    </td>
    <td>
      {{ contractor.country.name }}
    </td>
  </tr>
</template>

<script>
  import Contractor from '@/models/Contractor'

  export default {
    name: 'ContractorRow',
    props: {
      contractor: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        types: Contractor.typeData
      }
    },
    computed: {
      typeLabel() {
        let type = this.types.find(t => t.key === this.contractor.type)

        if (!type) return null

        return type.label
      }
    }
  }
</script>
